import _, { isEmpty } from 'lodash';
import React, {ReactElement, useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import LeftSideBar from '../layout/leftsidebar/LeftSideBar';
import { APPID, DEFAULT_ROUTE, MAIN_OPTIONS, NAV_SERVICES } from '../shared/constants/commonConstants';
import { fetchHospitalLogo } from '../store/actions/hospitalAction';
import { canActivate, checkIsSSo } from '../utils/utility';
import Header from './header/Header';
import './Main.less';
import ApplicationDetail from './../shared/services/applicationDetail.service';
import Cookies from 'js-cookie';
import AgreementModal from '../shared/components/modal/AgreementModal';
import { RootState } from '../store';
import { SideNavServiceOptions } from '../shared/models/common.model';
import { NewAdmissionState } from '../store/models/newAdmissionModel';
import { PayerInitialState } from '../store/models/payerListModel';
import { getIsPageGrievance } from '../modules/crm/inPatient/service/crmUtils';
const Main = ({ children }: any): ReactElement => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const hospitalProfileData = useSelector(({ hospital: { hospitalProfile } }: any): any => hospitalProfile);
  const hospitalLogoBytes = useSelector(({ hospital: { hospitalLogo } }: any): any => hospitalLogo);
  const authRedirectPath = useSelector((state: RootState): string => state.auth.authRedirectPath);
  const [sidebarHover, setSidebarHover] = useState<boolean>(false);
  const { isShowAdmissionForm, showBeneficiaryCard, beneficiaryList } =
    useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const isPreAuthNewDesignEnabled = ApplicationDetail.instance.getIsPreAuthNewDesignEnabled();
  const isGrievanceEnabled = ApplicationDetail.instance.getIsGrievanceEnabled();
  const isGrievancePage = getIsPageGrievance(location.pathname);
  const { payer: { isMemberSearchImageAllowed } } = useSelector((state: RootState): PayerInitialState =>
    state.payerList);

  const filteredNavServices = NAV_SERVICES
  .filter((nav: SideNavServiceOptions): boolean =>
    MAIN_OPTIONS.indexOf(nav.Id) >= 0 && canActivate(nav.accessCheckKeyword));
  useEffect((): void => {
    if (checkIsSSo() && ApplicationDetail.instance.getAccessToken()) {
      Cookies.remove('r2_dto');
      localStorage.clear();
      history.replace('/logout');
    }
  }, []);

  useEffect((): void => {
    if (hospitalProfileData) {
      fetchProfileDetail();
    }
    // eslint-disable-next-line
  }, [hospitalProfileData]);

  const fetchProfileDetail = async (): Promise<any> => {
    if (hospitalProfileData) {
      const response: any = hospitalProfileData[0]?.documentDetails?.filter((doc: any): boolean => doc.typeName === 'Logo');
      if (response && response.length > 0 && response[0].docId) {
        getFileBytes(_.orderBy(response, 'id', 'desc')[0].docId);
      }
    }
  };

  const getFileBytes = async (docId: any): Promise<void> => {
    const request = {
      applicationId: APPID,
      fileIdentifiers: [docId],
    };
    if (hospitalLogoBytes) {
      return;
    } else {
      dispatch(fetchHospitalLogo(request));
    }
  };

  if (!window.google) {
    const script: HTMLScriptElement = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}&libraries=geometry,places`;
    script.async = true;
    document.body.appendChild(script);
  }

  useEffect((): void => {
    if (authRedirectPath !== '/') {
      history.push(authRedirectPath);
    } else if (checkIsSSo() && history.location.pathname === '/') {
      history.push('/profile');
    } else if (history.location.pathname === '/') {
      const isRoutePresent = !!(filteredNavServices.find((ele: any): boolean => DEFAULT_ROUTE.includes(ele?.Id)));
      if (isRoutePresent) {
        history.push(DEFAULT_ROUTE);
      } else {
        history.push(`/${filteredNavServices[0]?.Id || ''}`);
      }
    }
  }, [history, children]);

  const onServiceChange = (service: string): void => {
    history.push(`/${service}`);
  };

  return (
    <section className="main-container">
      {!localStorage.getItem('isSSOLogin') && (
        <AgreementModal />
      )}
      <div className="fixed-leftnav" onMouseEnter={(): void => setSidebarHover(true)}
           onMouseOver={(): void => setSidebarHover(true)}
           onMouseLeave={(): void => setSidebarHover(false)}>
        <LeftSideBar onServiceChange={onServiceChange} sidebarHover={sidebarHover}/>
      </div>
      <div className="right-content">
        <Header />
        {/*
          NA-search-padding class adds padding to the end of the search panels if:
          - pre-auth new design is enabled
          - member search image is not allowed or beneficiary card is shown
          (the cards overlap on the guideline if this class is not removed)
          - admission form is not shown
        */}
        <div className={`content ${(isGrievanceEnabled && isGrievancePage)
            ? 'grievance-tab-container'
            : (isPreAuthNewDesignEnabled &&
              (!isMemberSearchImageAllowed || (showBeneficiaryCard && !isEmpty(beneficiaryList))) &&
              !isShowAdmissionForm)
              ? 'NA-search-padding'
              : ''
          }`}>
          {children}
        </div>
      </div>
    </section>
  );
};

export default Main;
